import React, { useContext, createContext, useState } from "react";
import { saveOpenedHints } from "../helpers/gameInsights";

const HintContainerContext = createContext();

export function HintContainerProvider({ children }) {
  const [queue, setQueue] = useState([]);
  const [visible, setVisible] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const [hintsArray, setHintsArray] = useState([]);
  const [gameLogin, setGameLogin] = useState("");
  const [documentId, setDocumentId] = useState(undefined);

  const getTime = () => {
    const getTimeNodes = document.getElementById("Timer").childNodes;
    const time = getTimeNodes[1].innerHTML;
    return time;
  };

  const clearHints = () => {
    setVisible([]);
    setQueue([]);
    setHintsArray([]);
    localStorage.removeItem(`HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}`);
    localStorage.removeItem(`HUISARREST_HINT_VISIBLE_QUEUE_${gameLogin}`);
    setShowWarning(false);
  };

  const addHintToQueue = (hint) => {
    //NOTE: this adds the hint to the queue, before opening by the player
    if (`HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}` in localStorage) {
      // find voor de hidden queue
      let oldItems = JSON.parse(
        localStorage.getItem(`HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}`)
      );

      let oldResult = oldItems.find((item) => {
        return item.id === hint.id;
      });

      let visibleItems =
        JSON.parse(
          localStorage.getItem(`HUISARREST_HINT_VISIBLE_QUEUE_${gameLogin}`)
        ) || [];

      let newResult = visibleItems.find((item) => {
        return item.id === hint.id;
      });

      if (oldResult || newResult) {
        return null;
      } else {
        oldItems.push(hint);
        localStorage.setItem(
          `HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}`,
          JSON.stringify(oldItems)
        );

        setQueue((queue) => [...queue, hint]);
      }
    } else {
      localStorage.setItem(
        `HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}`,
        JSON.stringify([hint])
      );

      setQueue((queue) => [...queue, hint]);
    }
  };

  let hint = "";

  const addHintToVisble = () => {
    // if the queue array is in localStorage
    if (`HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}` in localStorage) {
      let queu = JSON.parse(
        localStorage.getItem(`HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}`)
      );

      let visible =
        JSON.parse(
          localStorage.getItem(`HUISARREST_HINT_VISIBLE_QUEUE_${gameLogin}`)
        ) || [];

      visible.push(queu[0]);
      hint = queu.shift();

      localStorage.setItem(
        `HUISARREST_HINT_VISIBLE_QUEUE_${gameLogin}`,
        JSON.stringify(visible)
      );
      localStorage.setItem(
        `HUISARREST_HINT_HIDDEN_QUEUE_${gameLogin}`,
        JSON.stringify(queu)
      );

      // remove the hint from the queue
    }

    // const hint = queue[0];
    setVisible((visible) => [...visible, hint]);

    //Logic to store hint game insight to the db
    if (documentId !== "" || documentId !== null || documentId !== undefined) {
      //edit hint component for adding to insights DB.

      if (hint && hint.timeOpened) {
        // prev bug
        // timeOpened is not defined
        hint.timeOpened = getTime();
        hint.isOpened = true;

        delete hint.callback;

        let newQueue = [...visible, hint];
        saveOpenedHints(hint, documentId);
      }
    }
  };

  const removeHintFromQueue = () => {
    if (queue.length > 0) {
      const hintInQueue = queue[0];
      const indexOfHint = queue
        .map((hint) => {
          return hint.id;
        })
        .indexOf(hintInQueue.id);
      const filteredHints = queue
        .slice(0, indexOfHint)
        .concat(queue.slice(indexOfHint + 1, queue.length));
      setQueue(filteredHints);
    } else {
      return null;
    }
  };

  const checkWarning = () => {
    const hint = queue[0];

    if (
      hint.warning === null ||
      hint.warning === undefined ||
      hint.warning === false
    ) {
      addHintToVisble();
      removeHintFromQueue();
    } else {
      setShowWarning(true);
    }
  };

  return (
    <HintContainerContext.Provider
      value={{
        queue,
        setQueue,
        visible,
        setVisible,
        addHintToQueue,
        addHintToVisble,
        removeHintFromQueue,
        checkWarning,
        showWarning,
        setShowWarning,
        clearHints,
        hintsArray,
        setHintsArray,
        setGameLogin,
        setDocumentId,
      }}
    >
      {children}
    </HintContainerContext.Provider>
  );
}

export const useHintContainer = () => useContext(HintContainerContext);
